import { render } from "./EventsItem.vue?vue&type=template&id=ad0077c4&scoped=true&ts=true"
import script from "./EventsItem.vue?vue&type=script&lang=ts"
export * from "./EventsItem.vue?vue&type=script&lang=ts"

import "./EventsItem.vue?vue&type=style&index=0&id=ad0077c4&lang=stylus"
import "./EventsItem.vue?vue&type=style&index=1&id=ad0077c4&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0077c4"]])

export default __exports__